// // for local/dev (chatbot project)
// export const CHATBOT_ORIGIN = "http://localhost:5173";

// for Production (chatbot project domain)
export const CHATBOT_ORIGIN = "https://assist.justekyc.com";
